import { __decorate } from "tslib";
import { ColorDotsComponentNgModule } from '@gn-audio/angularjs-components/color-dots';
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { CannotFindMyProductComponent } from './cannot-find-my-product/cannot-find-my-product.component';
import { ProductFilterSelectComponent } from './product-filter-select/product-filter-select.component';
import { ProductSelectorSpotV2Controller } from './product-selector-spot-v2/product-selector-spot-v2.controller';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { DynamicPageSizeDirective } from './directives/dynamic-page-size.directive';
var moduleId = 'gn.audio.support.productselector';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('ProductSelectorSpotV2Controller', ProductSelectorSpotV2Controller);
var ProductSelectorModule = (function () {
    function ProductSelectorModule() {
    }
    ProductSelectorModule = __decorate([
        NgModule({
            declarations: [
                CannotFindMyProductComponent,
                ProductFilterSelectComponent,
                AutoFocusDirective,
                DynamicPageSizeDirective,
            ],
            id: moduleId,
            imports: [legacyModuleId, ColorDotsComponentNgModule.name],
            providers: [],
        })
    ], ProductSelectorModule);
    return ProductSelectorModule;
}());
export { ProductSelectorModule };
